import { render, staticRenderFns } from "./operation.vue?vue&type=template&id=710f5c37&scoped=true"
import script from "./operation.vue?vue&type=script&lang=js"
export * from "./operation.vue?vue&type=script&lang=js"
import style0 from "./operation.vue?vue&type=style&index=0&id=710f5c37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f5c37",
  null
  
)

export default component.exports